import React, { Component } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

import APIGet from '../../../API/APIGet';
import APIHelper from '../../../Helper/APIHelper';

import LoadingCenter from '../../../Components/LoadingCenter';
import InputRow from '../../../Components/InputRow';
import AuthRender from '../../../Components/AuthRender';

import ThingsToSelect from '../../../Helper/ThingsToSelect';

import { PROGRAM_STATUS } from '../../../StaticData/ProgramStatus';
import SEARCH_BY from '../../../StaticData/SearchBy';
import { ALLFITTYPES } from '../../../StaticData/FITTypes';
import TravelerHelper from '../../../Helper/Traveler';
import { toast } from 'react-toastify';
import AsyncSelect from 'react-select/async';

const ALL_TRAVELER_OPTION = {
	value: null,
	label: 'All - ทั้งหมด',
};

export default class Search extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			fitCustomers: [],
		};
	}

	componentDidMount = async () => {
		let requestFitCustomers = await APIGet('fit/customers');
		let fitCustomers = [];
		if (APIHelper.handleAPIResponse(this, requestFitCustomers)) {
			fitCustomers = ThingsToSelect(requestFitCustomers.data, true);
		}

		// console.log('fitCustomers: ', fitCustomers);
		this.setState({
			isLoading: false,
			fitCustomers,
		});
	};

	getDefaultTravelerOptions = () => {
		const { initTravelers } = this.props;
		return [
			ALL_TRAVELER_OPTION,
			...(initTravelers || []).map(t => ({
				value: t.id,
				label: TravelerHelper.getNameAndContact(t),
				travelerRecord: t,
			})),
		];
	};

	loadTravelerOptions = async inputValue => {
		const q = (inputValue || '').trim();
		if (!q) return this.getDefaultTravelerOptions();

		const request = await APIGet('travelers?page=1&perPage=40&filter=' + q);
		if (!APIHelper.handleAPIResponse(this, request)) {
			toast.error('ไม่สามารถดึงข้อมูล Traveler ได้ กรุณาลองใหม่อีกครั้ง');
			return [];
		}

		const responseData = request.data;
		const apiTravelers = Array.isArray(responseData) ? responseData : responseData.data || [];
		return [
			ALL_TRAVELER_OPTION,
			...apiTravelers.map(t => ({
				value: t.id,
				label: TravelerHelper.getNameAndContact(t),
			})),
		];
	};

	render() {
		if (this.state.isLoading) {
			return <LoadingCenter />;
		}

		const getTravelerLabel = option => {
			if (!option) return '';
			return option.label;
		};

		return (
			<div className="row">
				<div className="columns">
					<div className="column is-3">
						<label className="label">ประเภท</label>
						<Select
							name="fitType"
							value={this.props.fitType}
							clearable={false}
							onChange={value => this.props.onFilterChange('fitType', value)}
							options={ALLFITTYPES}
						/>
					</div>
					<div className="column is-3">
						<label className="label">ลูกค้า</label>
						<AsyncSelect
							name="traveler"
							value={this.props.selectedTraveler || ALL_TRAVELER_OPTION}
							clearable={false}
							onChange={traveler => {
								const travelerId = traveler && traveler.value != null ? traveler.value : null;
								this.props.onFilterChange('travelerId', travelerId);
								this.props.onFilterChange('selectedTraveler', traveler || ALL_TRAVELER_OPTION);
							}}
							defaultOptions={this.getDefaultTravelerOptions()}
							cacheOptions
							loadOptions={this.loadTravelerOptions}
							getOptionValue={option => option && (option.value != null ? option.value : option.id)}
							getOptionLabel={getTravelerLabel}
							loadingMessage={() => 'กำลังค้นหา...'}
							placeholder="ค้นหาจากชื่อ, เบอร์โทร, email"
							noOptionsMessage={() => 'ไม่มีข้อมูล Travel'}
						/>
					</div>
					<div className="column is-2">
						<label className="label">สถานะ</label>
						<Select
							name="status"
							value={this.props.status}
							clearable={false}
							onChange={value => this.props.onFilterChange('status', value)}
							options={PROGRAM_STATUS}
						/>
					</div>
					<div className="column is-2">
						<InputRow
							title="Invoice"
							labelSize="s"
							placeholder="Invoice"
							keyProps="invoice"
							onInputChange={this.props.onFilterChange}
							value={this.props.invoice}
							disabled={false}
							isMandatory={false}
						/>
					</div>
					<div className="column is-2">
						<label className="label">ประเภทวัน</label>
						<Select
							name="searchBy"
							value={this.props.searchBy}
							clearable={false}
							onChange={value => this.props.onFilterChange('searchBy', value)}
							options={SEARCH_BY}
						/>
					</div>
				</div>
				<div className="columns">
					<div className="column is-2">
						<label className="label">วันเริ่มต้น</label>
						<DatePicker
							selected={this.props.startDate}
							onChange={value => this.props.onFilterChange('startDate', value)}
							dateFormat="DD MMM YYYY"
							className="input"
						/>
					</div>
					<div className="column is-2">
						<label className="label">วันสิ้นสุด</label>
						<DatePicker
							selected={this.props.endDate}
							onChange={value => this.props.onFilterChange('endDate', value)}
							dateFormat="DD MMM YYYY"
							className="input"
						/>
					</div>
					<div className="column is-2">
						<AuthRender roles={['Admin', 'Manager', 'Finance']}>
							<InputRow
								title="พนักงาน"
								labelSize="s"
								placeholder="พนักงาน"
								keyProps="staffName"
								onInputChange={this.props.onFilterChange}
								value={this.props.staffName}
								disabled={false}
								isMandatory={false}
							/>
						</AuthRender>
					</div>
					<div className="column is-2" style={{ paddingTop: 45 }}>
						<button className="button is-info" onClick={this.props.search}>
							Filter
						</button>
						<span> </span>
						<button className="button is-warning" onClick={this.props.clearSearch}>
							Clear
						</button>
					</div>
				</div>
			</div>
		);
	}
}
